/* eslint-disable react-hooks/rules-of-hooks */
import {useEffect, useState} from 'react';

export const useMatchMedia = (query) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  const mediaMatch = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addEventListener('change', handler);

    return () => mediaMatch.removeEventListener('change', handler);
  });

  return matches;
};
